//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, T, MMinus } from "../../utils/MT";

// img
import LogoSvg from "../../assets/img/icon/logo.svg";
import UserSvg from "../../assets/img/icon/icon_user.svg";
import CartSvg from "../../assets/img/icon/icon_cart.svg";
import HeaderSvg from "../../assets/img/icon/icon_heart.svg";
import SearchSvg from "../../assets/img/icon/icon_search.svg";
import TopSvg from "../../assets/img/icon/icon_go_up.svg";
import ChatSvg from "../../assets/img/icon/icon_chat.svg";
import MenuSvg from "../../assets/img/icon/menu.svg";
import BackSvg from "../../assets/img/icon/back.svg";

//page
import HeaderMbSub from "./HeaderMbSub";

export default function Header() {
    const { pathname } = useLocation();

    // 프리오더 분기처리
    const [preOrder, setPreOrder] = useState(false);

    //페이지 이동
    const navigate = useNavigate();
    const goMyPage = () => {
        navigate(`/mypage/mymain`);
    };
    const goCartPage = () => {
        navigate(`/cart`);
    };
    const goWishPage = () => {
        navigate(`/wish`);
    };
    const goBack = () => {
        navigate(-1);
    };

    const [isLogin, setIsLogin] = useState(true); //로그인 상태
    const [mbMenuOpen, setmbMenuOpen] = useState(false); //모바일 서브메뉴
    const [mbSearchOpen, setMbSearchOpen] = useState(false); // 모바일 search 바

    // top 버튼
    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    // 검색
    const [searchWord, setSearchWord] = useState("");
    const goSearchPage = () => {
        if (searchWord.length == 0) {
            alert("검색어를 입력해주세요!");
            return;
        }
        navigate(`/searchResult/${searchWord}`);
    };

    const onKeyPress = (e) => {
        if (e.key == "Enter") {
            goSearchPage();
        }
    };

    return (
        <Warp>
            <Container>
                <FirstInnerCon>
                    {/* -------------- PC HeaderTop -------------- */}
                    <PC>
                        <LogoLink to="/">
                            <LogoImg src={LogoSvg} alt="신도리코 로고" />
                        </LogoLink>
                        {isLogin ? (
                            <UtilWrap>
                                <UtilList onClick={goMyPage}>
                                    <UserImg src={UserSvg} alt="유저 아이콘" />
                                </UtilList>
                                <UtilList onClick={goCartPage}>
                                    <CartImg src={CartSvg} alt="카트 아이콘" />
                                    {/* 카트안에 리스트가 0일땐 안보이게해주세요! */}
                                    <CountWrap>
                                        <Count>5</Count>
                                    </CountWrap>
                                </UtilList>

                                <UtilList onClick={goWishPage}>
                                    <HeartImg src={HeaderSvg} alt="위시리스트 아이콘" />
                                    {/* wish리스트 안에 리스트가 0일땐 안보이게해주세요! */}
                                    <CountWrap>
                                        <Count>5</Count>
                                    </CountWrap>
                                </UtilList>
                                <UtilList>
                                    <UtilLink to="/">Logout</UtilLink>
                                </UtilList>
                            </UtilWrap>
                        ) : (
                            <UtilWrap>
                                <UtilList>
                                    <UtilLink to="/login">Login</UtilLink>
                                </UtilList>
                                <UtilList>
                                    <UtilLink to="/signup">Sign up</UtilLink>
                                </UtilList>
                            </UtilWrap>
                        )}
                    </PC>

                    {/* -------------- Mobile HeaderTop -------------- */}

                    <Mobile>
                        <MobileIconWrap>
                            {pathname !== "/" && (
                                <BackBtnWrap onClick={goBack}>
                                    <BackIcon src={BackSvg} alt="닫기" />
                                </BackBtnWrap>
                            )}
                            <LogoLink to="/">
                                <LogoImg src={LogoSvg} alt="신도리코 로고" />
                            </LogoLink>
                        </MobileIconWrap>

                        <UtilWrap>
                            {isLogin ? (
                                <>
                                    <UtilList onClick={goMyPage}>
                                        <UserImg src={UserSvg} alt="유저 아이콘" />
                                    </UtilList>
                                    <UtilList onClick={goCartPage}>
                                        <CartImg src={CartSvg} alt="카트 아이콘" />
                                        {/* 카트안에 리스트가 0일땐 안보이게해주세요! */}
                                        <CountWrap>
                                            <Count>5</Count>
                                        </CountWrap>
                                    </UtilList>
                                </>
                            ) : null}
                            <MBSearchBtn>
                                <SearchIconImg onClick={() => setMbSearchOpen(!mbSearchOpen)} src={SearchSvg} alt="검색하기" />
                            </MBSearchBtn>
                            <MobHamburger
                                onClick={() => {
                                    setmbMenuOpen(true);
                                }}
                            >
                                <HambugerIcon src={MenuSvg} alt="메뉴" />
                            </MobHamburger>
                        </UtilWrap>
                    </Mobile>
                </FirstInnerCon>
            </Container>

            {/* -------------- Mobile SubMenu ( 위시리스트 / 메뉴) --------------*/}
            <HeaderMbSub mbMenuOpen={mbMenuOpen} setmbMenuOpen={setmbMenuOpen} isLogin={isLogin} preOrder={preOrder} />

            {/* -------------- PC Bottom SubMenu -------------- */}
            <PC>
                {!preOrder && (
                    <Container>
                        <SecInnerCon>
                            <NavWrap>
                                <NavList>
                                    <NavLink to="/product">3D PRT</NavLink>
                                </NavList>
                                <NavList>
                                    <NavLink to="/">Option</NavLink>
                                </NavList>
                                <NavList>
                                    <NavLink to="/">Supplies</NavLink>
                                </NavList>
                                <NavList>
                                    <NavLink to="/">AS part</NavLink>
                                </NavList>
                                <NavList gray>
                                    <NavLink to="/">OPTION</NavLink>
                                </NavList>
                                <NavList gray>
                                    <NavLink to="/">OPTION</NavLink>
                                </NavList>
                                <NavList gray>
                                    <NavLink to="/">OPTION</NavLink>
                                </NavList>
                                <NavList gray>
                                    <NavLink to="/">OPTION</NavLink>
                                </NavList>
                            </NavWrap>

                            {/* 검색 */}
                            <SearchBarWrap>
                                <SearchInput
                                    value={searchWord}
                                    onKeyPress={onKeyPress}
                                    onChange={(e) => {
                                        setSearchWord(e.target.value);
                                    }}
                                    type="text"
                                    placeholder="상품 검색어 입력"
                                />
                                <SearchBtn>
                                    <SearchIconImg onClick={goSearchPage} src={SearchSvg} alt="검색하기" />
                                </SearchBtn>
                            </SearchBarWrap>
                        </SecInnerCon>
                    </Container>
                )}
            </PC>

            {/* Mobil Bottom Search */}
            <Mobile>
                {mbSearchOpen && (
                    <SearchContainer>
                        <SearchBarWrap>
                            <SearchInput
                                value={searchWord}
                                onKeyPress={onKeyPress}
                                onChange={(e) => {
                                    setSearchWord(e.target.value);
                                }}
                                type="text"
                                placeholder="상품 검색어 입력"
                            />
                            <SearchBtn>
                                <SearchIconImg
                                    onClick={() => {
                                        goSearchPage();
                                    }}
                                    src={SearchSvg}
                                    alt="검색하기"
                                />
                            </SearchBtn>
                        </SearchBarWrap>
                    </SearchContainer>
                )}
            </Mobile>

            {/* 고정아이콘 */}
            <FixedBtnWrap>
                <ChatBtn>
                    <ChatImg src={ChatSvg} alt="채팅 아이콘" />
                </ChatBtn>
                <TopBtn
                    onClick={() => {
                        scrollTop();
                    }}
                >
                    <TopImg src={TopSvg} alt="위로가기 아이콘" />
                </TopBtn>
            </FixedBtnWrap>
        </Warp>
    );
}

const Warp = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;

    z-index: 10;
    background: #fff;

    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
`;

const Container = styled.div`
    position: relative;

    border-bottom: 1px solid #eee;
`;

const FirstInnerCon = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    height: calc(100vw * (70 / 1920));

    margin: 0 auto;

    display: flex;
    align-items: center;

    /* padding: calc(100vw * (21 / 1920)) 0; */

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        height: calc(100vw * (70 / 1300));

        /* padding: calc(100vw * (21 / 1300)) 0; */
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        height: ${M(51)};

        justify-content: space-between;

        padding: ${M(16)} 0;
    }
`;

const MobileIconWrap = styled.div`
    display: flex;
    align-items: center;
`;

const BackBtnWrap = styled.div`
    width: ${M(12)};
    height: ${M(18)};

    cursor: pointer;

    margin-right: ${M(21)};
`;

const BackIcon = styled.img`
    display: block;
    width: 100%;
    height: 100%;
`;

const MobHamburger = styled.li`
    width: ${M(18)};
    height: ${M(14)};

    cursor: pointer;
`;

const HambugerIcon = styled.img`
    display: block;
    width: 100%;
    height: 100%;
`;

const SecInnerCon = styled(FirstInnerCon)`
    padding: calc(100vw * (11 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (11 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(16)} 0;
    }
`;

const LogoLink = styled(Link)`
    width: calc(100vw * (151 / 1920));
    height: calc(100vw * (18 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (151 / 1300));
        height: calc(100vw * (18 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(120)};
        height: ${M(15)};
    }
`;

const LogoImg = styled.img`
    display: block;
    width: 100%;
    height: 100%;
`;

const UtilWrap = styled.ul`
    position: relative;

    display: flex;
    align-items: center;
    margin-left: auto;

    margin-right: calc(100vw * (30 / 1920));
    & > li:not(:first-child) {
        margin-left: calc(100vw * (30 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-right: calc(100vw * (30 / 1300));
        & > li:not(:first-child) {
            margin-left: calc(100vw * (30 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        justify-content: flex-end;

        margin-right: 0;

        @media screen and (max-width: 900px) {
            & > li:not(:first-child) {
                margin-left: ${M(20)};
            }
        }
    }
`;

const UtilList = styled.li`
    position: relative;

    cursor: pointer;
`;

const UtilLink = styled(Link)`
    display: block;
    font-family: "Pop-M";

    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }
`;

const UserImg = styled.img`
    width: calc(100vw * (16 / 1920));
    height: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (16 / 1300));
        height: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(14)};
        height: ${M(17)};
    }
`;

const CartImg = styled.img`
    width: calc(100vw * (21 / 1920));
    height: calc(100vw * (21 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (21 / 1300));
        height: calc(100vw * (21 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(17)};
        height: ${M(17)};
    }
`;

const HeartImg = styled.img`
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (21 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (21 / 1300));
    }
`;

const CountWrap = styled.div`
    position: absolute;
    top: calc(100vw * (-5 / 1920));
    right: calc(100vw * (-12 / 1920));

    display: flex;
    min-width: calc(100vw * (18 / 1920));
    height: calc(100vw * (18 / 1920));
    line-height: calc(100vw * (18 / 1920));

    padding: 0 calc(100vw * (2 / 1920));

    border: 1px solid #fff;
    background: var(--main-color);

    border-radius: 50%;

    @media screen and (max-width: 1300px) {
        top: calc(100vw * (-5 / 1300));
        right: calc(100vw * (-12 / 1300));

        min-width: calc(100vw * (18 / 1300));
        height: calc(100vw * (18 / 1300));
        line-height: calc(100vw * (18 / 1300));

        padding: 0 calc(100vw * (2 / 1300));
    }

    @media screen and (max-width: 900px) {
        top: ${M(2)};
        right: ${M(-10)};

        padding: 0 ${M(2)};

        min-width: ${M(15)};
        height: ${M(15)};
        line-height: ${M(15)};
    }
`;

const Count = styled.p`
    font-family: "Pop-M";
    font-size: calc(100vw * (10 / 1920));
    color: #fff;

    margin: auto;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(9)};
    }
`;

const NavWrap = styled.ul`
    flex: 1;
    display: flex;
`;

const NavList = styled.li`
    &:not(:first-child) {
        margin-left: calc(100vw * (40 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-left: calc(100vw * (40 / 1300));
        }
    }

    ${({ gray }) => {
        return (
            gray &&
            `
                & a{color:#CECECE;}
            `
        );
    }}
`;

const NavLink = styled(Link)`
    display: block;
    font-family: "Pop-M";
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }
`;

const SearchContainer = styled.div`
    padding: ${M(16)} 0;
`;

const SearchBarWrap = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (290 / 1920));

    padding: calc(100vw * (10 / 1920)) calc(100vw * (20 / 1920));
    border-radius: 50px;
    border: 1px solid #ddd;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (290 / 1300));

        padding: calc(100vw * (10 / 1300)) calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;

        padding: ${M(8)} ${M(20)};
    }
`;

const SearchInput = styled.input`
    width: calc(100% - 100vw * (20 / 1920));
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100% - 100vw * (20 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }
    @media screen and (max-width: 900px) {
        width: ${MMinus(20)};
        font-size: ${M(13)};
    }
`;

const SearchBtn = styled.div`
    width: calc(100vw * (16 / 1920));
    height: calc(100vw * (16 / 1920));

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (16 / 1300));
        height: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(17)};
        height: ${M(17)};
    }
`;

const MBSearchBtn = styled.li`
    width: calc(100vw * (16 / 1920));
    height: calc(100vw * (16 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (16 / 1300));
        height: calc(100vw * (16 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(17)};
        height: ${M(17)};
        cursor: pointer;
    }
`;

const SearchIconImg = styled.img`
    display: block;
    width: 100%;
    height: 100%;
`;
const FixedBtnWrap = styled.aside`
    position: fixed;
    right: calc(100vw * (250 / 1920));
    bottom: calc(100vw * (100 / 1920));

    @media screen and (max-width: 1300px) {
        right: calc(100vw * (50 / 1300));
        bottom: calc(100vw * (100 / 1300));
    }

    @media screen and (max-width: 900px) {
        right: ${M(25)};
        bottom: ${M(55)};
    }
`;

const ChatBtn = styled.div`
    display: flex;
    width: calc(100vw * (70 / 1920));
    height: calc(100vw * (70 / 1920));
    /* background: #FF5F00; */
    background: var(--main-color);
    border-radius: 50%;

    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (70 / 1300));
        height: calc(100vw * (70 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(50)};
        height: ${M(50)};
    }
`;

const ChatImg = styled.img`
    width: calc(100vw * (35 / 1920));
    height: calc(100vw * (34 / 1920));

    margin: auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (35 / 1300));
        height: calc(100vw * (34 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(25)};
        height: ${M(24)};
    }
`;

const TopBtn = styled(ChatBtn)`
    background: #fff;

    margin-top: calc(100vw * (18 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (18 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(13)};
    }
`;

const TopImg = styled.img`
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));

    margin: auto;
    transform: rotate(-90deg);

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(14)};
        height: ${M(14)};
    }
`;
